export enum StatusAnalise{   
        EM_ANALISE = 0,
        DEFERIDA = 1,
        INDEFERIDA = 2,
}

